// @ts-check
// =============================================================================
// js/app/login-link.js — the one-click "?login=<provider>" deep link.
//
// WHAT THIS IS
//   The Patreon "How To Play" guide ends with a "Play Deckbiter (logged in)"
//   button pointing at deckbiter.cards/?login=patreon. That link must take a
//   brand-new player straight through Patreon's OAuth (no login picker), yet
//   be harmless for someone who is already logged in. session.js asks this
//   module what to do; the OAuth URLs themselves stay in session.js
//   (LOGIN_PROVIDERS), so the guide's link never embeds a client id and keeps
//   working if those ever change.
//
//   A leaf module (no imports) so node --test can exercise it directly — same
//   pattern as shell-mode.js / quickplay-mode.js.
// =============================================================================

/** The query parameter the guide's button sets. */
export const LOGIN_PARAM = 'login';

/**
 * Which provider does this URL's ?login= ask for?
 * Matches a provider's label case-insensitively ("patreon" -> "Patreon").
 * Hidden providers (kept only for re-auth) never match.
 * @param {string} search  window.location.search
 * @param {Array<{label: string, url: string, hidden?: boolean}>} providers
 * @returns {{label: string, url: string}|null}
 */
export function loginLinkProvider(search, providers) {
	let wanted;
	try {
		wanted = new URLSearchParams(search).get(LOGIN_PARAM);
	} catch {
		return null;
	}
	if (!wanted) return null;
	wanted = wanted.trim().toLowerCase();
	return providers.find((p) => !p.hidden && p.label.toLowerCase() === wanted) || null;
}

/**
 * The same URL with ?login= removed (everything else kept), for tidying the
 * address bar once the link has done its job.
 * @param {string} href
 * @returns {string}
 */
export function withoutLoginParam(href) {
	const url = new URL(href);
	url.searchParams.delete(LOGIN_PARAM);
	return String(url);
}
